var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-editor',{ref:"editor",attrs:{"id":"editor","editorOptions":_vm.editorOptions,"placeholder":_vm.placeholder},model:{value:(_vm.contents),callback:function ($$v) {_vm.contents=$$v},expression:"contents"}})}
var staticRenderFns = []

export { render, staticRenderFns }